export const HANDBOOK_PATH = '/handbook';
export const CRM_PATH = '/crm';
export const OPPORTUNITY_PATH = '/crm/opportunities';
export const STAFFING_DASHBOARD_PATH = '/staffing-project-dashboard';
export const OPPORTUNITY_DASHBOARD_PATH = '/staffing-opportunity-dashboard';
